module.exports = __webpack_public_path__ + "img/打开符号.46e6991b.svg";